<app-pan-chip [width]="70" [color]="color()" [label]="state()"></app-pan-chip>
